export const trustSignals = [{
  id: 'app-count',
  stats: '8,000 +',
  label: 'App listings',
  cardStyles: {
    backgroundColor: "var(--ds-surface-raised, #FFFFFF)",
    border: "1px solid ".concat("var(--ds-border-accent-magenta, #CD519D)"),
    slabColor: "var(--ds-border-accent-magenta, #CD519D)"
  },
  statsStyles: {
    color: "var(--ds-text-accent-magenta, #943D73)"
  }
}, {
  id: 'install-count',
  stats: '1.2M +',
  label: 'Installs',
  cardStyles: {
    backgroundColor: "var(--ds-surface-raised, #FFFFFF)",
    border: "1px solid ".concat("var(--ds-border-accent-lime, #6A9A23)"),
    slabColor: "var(--ds-border-accent-lime, #6A9A23)"
  },
  statsStyles: {
    color: "var(--ds-text-accent-lime, #4C6B1F)"
  }
}, {
  id: 'partner-count',
  stats: '1,800 +',
  label: 'Partners',
  cardStyles: {
    backgroundColor: "var(--ds-surface-raised, #FFFFFF)",
    border: "1px solid ".concat("var(--ds-border-accent-blue, #1D7AFC)"),
    slabColor: "var(--ds-border-accent-blue, #1D7AFC)"
  },
  statsStyles: {
    color: "var(--ds-text-information, #0055CC)"
  }
}];